import type { GridColDef, GridRowId, GridValidRowModel, GridValueGetter } from '@mui/x-data-grid-premium';

type GridApiRef = Parameters<GridValueGetter>[3];

/** The cell context used by the existing grid formatters and bulk-edit helpers. */
export interface LegacyGridValueParams<R extends GridValidRowModel = any, V = any> {
	value: V;
	row: R;
	field: string;
	id: GridRowId;
	colDef: GridColDef<R>;
	api: GridApiRef['current'];
}

/** Preserve existing cell callbacks when MUI X 7 supplies positional arguments. */
export function adaptGridValueCallback<R extends GridValidRowModel = any, Result = any>(
	callback: (params: LegacyGridValueParams<R>) => Result,
) {
	return (value: any, row: R, column: GridColDef<R>, apiRef: GridApiRef): Result =>
		callback({
			value,
			row,
			field: column.field,
			get id() {
				return apiRef.current.getRowId(row);
			},
			colDef: column,
			api: apiRef.current,
		});
}
